import React, { useEffect, useState } from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from './styles'
import { getUserTheme } from 'shared-ui/utils/localStorage'
import {
  backBtn,
  backBtnBlack,
  BookmarkIcon,
  BookmarkIconLight,
  LikeIcon,
  LikeIconLight,
  CommentIcon,
  CommentIconLight,
  shareIcon,
  shareIconLight,
  MoreVerticalIcon,
  MoreVerticalIconLight,
  CloseIcon,
  CloseIconLight,
  starAnimateLight,
  starAnimate,
  zodiacWheel,
  zodiacWheelLight,
  starHead,
  starHeadLight,
  StarVector,
  StarVectorLight,
  starsDark,
  starsLight
} from 'shared-ui/assets'

// theme.js
const base = {
  colors: {
    powderWhite: '#FFFDF9',
    persianGreen: '#06B49A',
    lightBlue: '#AFDBD2',
    onyx: '#36313D',
    background: '#191c22',
    black: '#181c23',
    Blue: '#00B8F8',
    Black: '#050505',
    Ash: '#CCCCCC',
    DarkCharcoal: '#333333',
    White: '#FFFFFF',
    Green: '#5CB617',
    Cyan: '#00B8F866',
    Darkgray: '#050505',
    Granite: '#666666',
    Smoke: '#F3F3F3',
    Red: '#EE2E20',
    RedInput: 'ff7a7a',
    Darkcyan: '#0B2A33',
    grey: '#373737',
    MidGray: '#999999',
    tealGreen: '#169595',
    purple: '#B2AFFE',
    VividBlue: '#21C6FF',
    Transparent: 'transparent',
    Yellow_600:"#ca8a04",
    Yellow_500:"#eab308",
    Blue_600:"#2563eb",
    Blue_500:"#3b82f6",
    Red_500:"#E27D7D"

  },
  fonts: {
    fontFamily: 'Poppins, sans-serif',
    fontSizes: {
      fontSize28: '28px',
      small: '1em',
      medium: '2em',
      large: '3em'
    },
    fontWeight: {
      fontWeight600: '600'
    },
    lineHeight: {
      lineHeight34: '34px'
    }
  },
  icons: {}
}

export const lightTheme = {
  ...base,
  app: {
    background: '#F3F3F3',
    dashboardCardsBG: '#FFFFFF',
    dashboardCardsBGWeb: '#FFFFFF',
    dashboardBG: '#F5F5F5',
    uploadIconBg: '#FFFFFF',
    text: '#050505',
    inActiveText:'#050505B3',
    card: '#F3F3F3',
    border: '#CCCCCC',
    accent: '#00B8F8',
    upload: '#05050533',
    iconFilter: 'brightness(0) saturate(0%) opacity(0.4)',
    boxShadow: '',
    tabSelectedicon: '#00B8F833',
    railCardBg:'#0215339E',
    iconlabel: '#666666',
    settingCardBg: '#0505050A',
    backBtn: backBtnBlack,
    CloseIcon: CloseIconLight,
    backdropStyle: '#00000080',
    loginPageBg: '#F3F3F3',
    boxBorder: '#e5e7eb',
    sideBarIcon: 'brightness(0) saturate(0%) opacity(0.7)',
    labelBg: 'white',
    optionsBg: 'white',
    optionHoverBg:'#e5e5e5',
    inputLabelBg: 'white',
    inviteInput: '#FFFFFF',
    eternalUpload: '#FFFFFF',
    eternalUplaodBox: '#00B8F80D',
    eternalUploadBorder: '#00B8F8',
    inputBorder: '#666666',
    tooltipBg:'#F3F3F3',
    sidepanelBg: '#FFFFFF',
    welcomeDesc: '#6C7278',
    starAnimateScreen: starAnimateLight,
    mobileStarAnimateScreen: starHeadLight,
    zodiacWheelImg: zodiacWheelLight,
    eternalDescription: '#666666',
    harmonySubTitle: '#FFFFFF',
    harmonyStatus: '#FFFFFF',
    summaryPointsBG:
      'linear-gradient(180deg, rgba(42, 22, 159, 1) 0%, rgba(145, 174, 232, 1) 100%)',
    eternalAiHeader: '#00B8F8',
    starVector: StarVectorLight,
    vibrationalCardBg:
      'linear-gradient(180deg, rgb(255, 255, 255) 70%, rgba(0, 184, 248, 0.1) 100%)',
    flameIconBg: '#00B8F8',
    eternalFaqBg: '#fff',
    eternalChatSendBtn: '#00B8F8',
    tarotFormLabel: '#666666',
    walletLabel: '#CCCCCC',
    audioControllers: '#E9E9E9',
    spDashboardHeroSection:
      'linear-gradient(180deg, rgba(0, 26, 60, 0.6) 22.07%, #F5F5F5 100%)',
    WelcomeBannerBG:
      'linear-gradient(113.64deg, rgba(0, 97, 255, 1) 7.83%, rgba(96, 239, 255, 1) 100.26%);',
    QuestionBG: '#F2F4F5',
    QuestionBorder: '#F2F4F5',
    bookmarkIcon: BookmarkIconLight,
    likeIcon: LikeIconLight,
    commentIcon: CommentIconLight,
    shareIcon: shareIconLight,
    moreVerticalIcon: MoreVerticalIconLight,
    imageBorder: '#050505',
    rashiChartActionButton: '#CCCCCC33',
    stars: starsLight,
    green:'#006400',
    red:'#8B0000',
    subText:"#fffffffc",
    subBg:"#05050526",
    bgGray:"#CCCCCC90",
    iconHoverBg:"rgba(0, 0, 0, 0.06)",
    iconColor:"#6b7280",
    bgLight:"#f5f5f5",
    skeletonEdge: "#cbdadd",
    skeletonBase: "#d9e6e8",
    skeletonShine: "#edf5f6",
    skeletonMutedEdge: "#d4d4d8",
    skeletonMutedBase: "#e4e4e7",
    skeletonMutedShine: "#f4f4f5",
    bgGrayLight:"#1E2128",
    borderGrayLight:"#2D3138",
    subTextColor:"#9EA3AB",
    bgDashaboradGray:"#30303024",
    bgNotification:"#F3F3F3",
  }
}

export const darkTheme = {
  ...base,
  app: {
    background: '#050505',
    dashboardCardsBG: '#1E2123',
    dashboardCardsBGWeb: '#FFFFFF0A',
    dashboardBG: '#050505',
    text: '#FFFFFF',
    inActiveText:'#FFFFFFB3',
    card: '#181c23',
    border: '#333333',
    accent: '#00B8F8',
    upload: '#FFFFFF33',
    uploadIconBg: '#FFFFFF33',
    iconFilter: 'brightness(0) invert(1) opacity(0.7)',
    boxShadow: '0 2px 8px #0002',
    tabSelectedicon: '#022733',
    railCardBg: '#00B8F833',
    iconlabel: '#CCCCCC',
    settingCardBg: '#FFFFFF1A',
    backBtn: backBtn,
    CloseIcon: CloseIcon,
    backdropStyle: '#000000A3',
    loginPageBg: '#050505',
    boxBorder: '#333',
    sideBarIcon: 'brightness(0) invert(1) opacity(1)',
    labelBg: '#050505',
    optionsBg: '#262626',
    optionHoverBg: '#262626',
    inputLabelBg: '#373737',
    inviteInput: '#041D26',
    eternalUpload: '#FFFFFF0A',
    eternalUploadBorder: '#FFFFFF33',
    eternalUplaodBox: '#FFFFFF0A',
    inputBorder: '#666666',
    tooltipBg:'#CCCCCC',
    sidepanelBg: '#1E2123',
    welcomeDesc: '#FFFFFF',
    starAnimateScreen: starAnimate,
    zodiacWheelImg: zodiacWheel,
    mobileStarAnimateScreen: starHead,
    eternalDescription: '#999999',
    harmonySubTitle: '#999999',
    harmonyStatus: '#00B8F8',
    summaryPointsBG:
      'linear-gradient(180deg, rgba(42, 22, 159, 0.3) 0%, rgba(145, 174, 232, 0.3) 100%)',
    eternalAiHeader: '#FFFFFF',
    starVector: StarVector,
    vibrationalCardBg:
      'linear-gradient( 180deg, rgb(30, 30, 30) 70%, rgba(0, 184, 248, 0.2) 100%)',
    flameIconBg: '#ffffff',
    eternalFaqBg: '#333333',
    eternalChatSendBtn: '#CCCCCC',
    tarotFormLabel: '#FFFFFF',
    walletLabel: '#333333',
    audioControllers: '#FFFFFF',
    spDashboardHeroSection:
      'linear-gradient(180deg, rgba(0, 26, 60, 0.6) 0%, #050505 100%)',
    WelcomeBannerBG: '#00B8F833',
    QuestionBG: '#FFFFFF0D',
    QuestionBorder: '#FFFFFF33',
    bookmarkIcon: BookmarkIcon,
    likeIcon: LikeIcon,
    commentIcon: CommentIcon,
    shareIcon: shareIcon,
    moreVerticalIcon: MoreVerticalIcon,
    imageBorder: '#FFFFFF33',
    rashiChartActionButton: '#2F2F2FCC',
    stars: starsDark,
    green:'#4ADE80',
    red:'#F87171',
    subText:"#CCCCCC",
    subBg:"#FFFFFF26",
    bgGray:"#66666680",
    iconHoverBg:" rgba(255, 255, 255, 0.08)",
    iconColor:"#9ca3af",
    bgLight:"#101828",
    skeletonEdge: "#16262b",
    skeletonBase: "#1d3136",
    skeletonShine: "#2c484f",
    skeletonMutedEdge: "#1d1d1f",
    skeletonMutedBase: "#27272a",
    skeletonMutedShine: "#343438",
    bgGrayLight:"#1E2128",
    borderGrayLight:"#2D3138",
    subTextColor:"#9EA3AB",
    bgDashaboradGray:"#303030",
    bgNotification:"#0F0F12",
  }
}

const Theme = ({ children }) => {
  const [themeMode, setThemeMode] = useState(getUserTheme() || 'dark')
  useEffect(() => {
    const handleThemeChange = (e) => {
      const newTheme = e.detail || getUserTheme()
      setThemeMode(newTheme)
    }
    const handleStorage = () => {
      setThemeMode(getUserTheme() || 'dark')
    }
     window.addEventListener('themeChange', handleThemeChange)

    // Listen for localStorage changes (in case multiple tabs open)
    window.addEventListener('storage', handleStorage)
    return () => {
      window.removeEventListener('themeChange', handleThemeChange)
      window.removeEventListener('storage', handleStorage)
    }
  }, [])

  const selectedTheme =
    themeMode.toLowerCase() === 'dark' ? darkTheme : lightTheme

  return (
    <ThemeProvider theme={selectedTheme}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  )
}

export default Theme
